// This file imports all images statically so webpack can process them

import * as recordingsSimplifiedMainImages from './RecordingsSimplified/mainImage';
import * as recordingsSimplifiedLearnMoreImages from './RecordingsSimplified/learnMoreBlocksImages';
import * as recordingsSimplifiedGettingStartedImages from './RecordingsSimplified/gettingStartedStepsImages';
import * as recordingsSimplifiedFeatureGridIcons from './RecordingsSimplified/featureGridIconImages';

export const featureImages = {
	'recordings-simplified': {
		...recordingsSimplifiedMainImages,
		learnMoreBlocksImages: recordingsSimplifiedLearnMoreImages,
		gettingStartedStepsImages: recordingsSimplifiedGettingStartedImages,
		featureGridIconImages: recordingsSimplifiedFeatureGridIcons,
	},
} as const;

export type FeatureImages = typeof featureImages;
export type FeatureType = keyof FeatureImages;
